import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlayerCardListComponent } from './player-list-card/player-list-card.component';
import { PlayerService } from '../../controller/player.service';
import { PlayerListItem } from '../../model/player';
import { PlayerSearchBarComponent } from './player-search-bar/player-search-bar.component';

@Component({
  selector: 'app-player-selector',
  templateUrl: 'player-selector.component.html',
  styleUrls: ['player-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, PlayerCardListComponent,PlayerSearchBarComponent],
})
export class PlayerSelectorComponent implements OnInit {

  @Output() playerSelected: EventEmitter<PlayerListItem> = new EventEmitter<PlayerListItem>();

  players: PlayerListItem[] = [];
  selectedPlayer: PlayerListItem | null = null;

  constructor(
    private playerService: PlayerService
  ) { }

  ngOnInit() {
    this.players = this.playerService.getPlayers().sort((p1,p2) => p1.tShirtNumber - p2.tShirtNumber);
    this.onPlayerSelected(this.players[0]);
  }

  onPlayerSelected(player: PlayerListItem) {
    this.selectedPlayer = player;
    this.playerSelected.emit(player);
  }

}
